import { fromJS } from 'immutable';

export default fromJS({
    insuranceInfo: undefined,
});
